"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FormatButton_1 = __importDefault(require("../../../atoms/FormatButton"));
const providers_1 = require("../../../providers");
const hooks_1 = require("../../../hooks");
const ui_1 = require("@completeanatomy/ui");
function HeadingFormatButton() {
    const [{ fontSize }, dispatch] = (0, providers_1.useRichTextContext)();
    const onClick = () => {
        (0, hooks_1.setTextStyle)(hooks_1.TextStyle.FontSize, '6');
        dispatch((0, hooks_1.updateTextStyles)());
    };
    return ((0, jsx_runtime_1.jsx)(FormatButton_1.default, { selected: fontSize === '6', iconName: ui_1.Icons.Formatting_Heading, onClick: onClick, "data-e2e": 'HeadingFormatButton_FormatButton' }));
}
exports.default = HeadingFormatButton;
